<template>
	<ui-dialog
		ref="dialog"
		title="Storage"
		closable
	>
		<p>Storage used (h:m:s): {{ storageSecs | timecode }}</p>
	</ui-dialog>
</template>

<script>
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";
import UiDialog from "lib/components/ui/Dialog";

export default {
	name: "StorageDialog",
	components: {
		UiDialog
	},
	props: {
		recorder: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			storageSecs: this.recorder.storage_secs
		};
	},
	mounted() {
		this.open = () => {
			this.getRecorder();
			this.$refs.dialog.open();
		};
	},
	methods: {
		getRecorder() {
			http.get(`/api/v2/recorder/${this.recorder.recorder_id}`)
			.then((response) => {
				this.storageSecs = response.data.storage_secs;
			})
			.catch((error) => {
				alert.error("Unable to get recorder", error.response);
			});
		}
	}
};
</script>
